import { FunctionComponent } from 'react';

import { BreakPoints, Button, Icon, Text } from '@kanda-libs/ks-design-library';

import useDeclined from './useDeclined';

const Declined: FunctionComponent = () => {
  const { failureUrl, companyName, provider, isLoading } = useDeclined();

  return (
    <div className="flex flex-col">
      <BreakPoints
        desktop={
          <Icon
            icon="currency"
            size={24}
            className="mb-4"
            isLoading={isLoading}
          />
        }
      />
      <Text
        text={`Unfortunately, your finance application was declined by the lender: ${provider}`}
        className="mb-3 text-14-22-em md:text-20-24-em text-neutral-700 md:text-neutral-900 md:mb-6"
        isLoading={isLoading}
      />
      <Text
        text={`${companyName} has been notified that your finance application was declined. If you still want the work to go ahead without finance, please get in touch with ${companyName}.`}
        className="mb-2 text-14-22 text-neutral-600 md:mb-4"
        isLoading={isLoading}
      />

      {failureUrl && (
        <>
          <Text
            text={`You will automatically be redirected back to ${companyName}'s website in 10 seconds, or you can click the below button.`}
            className="mt-10 mb-4 text-14-22 text-neutral-600 md:mb-6"
            isLoading={isLoading}
          />
          <a href={failureUrl} className="flex w-full">
            <Button.Text
              id="declined-return-to-website"
              label="Return to website"
              className="w-full"
            />
          </a>
        </>
      )}
    </div>
  );
};

export default Declined;
